import { companies, endpoints, getDemoUrl } from './content/demo';
import config from './config';

const demo = document.querySelector('[data-api-demo]');
if (demo) {
  let company = companies[0][0];
  let endpoint = endpoints[2][0];
  let controller;
  let responseText = '';
  const status = demo.querySelector('[data-demo-status]');
  const output = demo.querySelector('[data-demo-response]');
  const request = demo.querySelector('[data-demo-request]');
  const copy = demo.querySelector('[data-demo-copy]');
  const fetchDemo = async () => {
    controller?.abort();
    const active = new AbortController();
    controller = active;
    const url = getDemoUrl(config.BackendUrl, endpoint, company);
    request.textContent = `curl '${new URL(url, window.location.href).href}'`;
    status.textContent = 'Henter…';
    copy.hidden = true;
    try {
      const response = await fetch(url, { signal: active.signal });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      const data = await response.json();
      if (controller !== active) return;
      responseText = JSON.stringify(data, null, 2);
      const lines = responseText.split('\n');
      output.textContent = lines.slice(0, 500).join('\n') + (lines.length > 500 ? `\n… ${lines.length - 500} linjer mere. Kopier for hele svaret.` : '');
      status.textContent = '200 OK';
      copy.textContent = 'Kopier';
      copy.hidden = false;
    } catch (error) {
      if (controller !== active || error.name === 'AbortError') return;
      status.textContent = `Kunne ikke hente demoen: ${error.message}`;
      output.textContent = 'Vælg en virksomhed eller et endpoint for at prøve igen.';
    }
  };
  demo.addEventListener('click', event => {
    const button = event.target.closest('[data-company], [data-endpoint]');
    if (!button) return;
    if (button.dataset.company) company = button.dataset.company;
    if (button.dataset.endpoint) endpoint = button.dataset.endpoint;
    for (const option of demo.querySelectorAll('[data-company], [data-endpoint]')) {
      option.setAttribute('aria-pressed', String(option.dataset.company === company || option.dataset.endpoint === endpoint));
    }
    fetchDemo();
  });
  copy.addEventListener('click', async () => {
    try {
      await navigator.clipboard.writeText(responseText);
      copy.textContent = 'Kopieret!';
    } catch { status.textContent = 'Kopiering mislykkedes. Markér og kopiér svaret.'; }
  });
  fetchDemo();
}
